import React from 'react';
import { Grid, useTheme } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useAppContext } from 'hooks/useAppContext';
import { InspectionComment } from 'classes';
import { getInspectionComments } from 'utils/InspectionCommentUtil';
import withAppStylesGrid from 'HOCs/withAppStyles';
import SkeletonGrid from 'components/Shared/SkeletonGrid';


function InspectionCommentsDataTable ({customFilter}) {
    const title = "Comments";
    const theme = useTheme();
    const { selectedProject } = useAppContext();
    const columns = InspectionComment.columns;
    console.log(customFilter)
  
    const WrappedGrid = withAppStylesGrid(MaterialTable, { projectID: selectedProject, getRecords: getInspectionComments, theme, defaultFilters: { 
        ProjectId_WorkItem: selectedProject, 
          ...customFilter 
    } })
    
  
    return (
      selectedProject && theme ?
        <>
          <Grid container>
            <Grid item xs={12}>
              <WrappedGrid
                columns={columns}
                title={title}
                options={{
                  pageSize: 15,
                  pageSizeOptions: [15, 20, 25],
                  padding: 'dense'
                }}
              />
            </Grid>
           
          </Grid>
        </>
        : <SkeletonGrid title={title} />
    )
}

export default InspectionCommentsDataTable;